import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import revLL from './assets/revLL.png'
import mir from './assets/mir.png'
import lps from './assets/lps.svg'
import Max from './assets/Max.png'
import sub from './assets/sub.png'
import dpl from './assets/dpl.png'
import twojug from './assets/twojug.jfif'
import mcp from './assets/mcp.jpg'
import transpose from './assets/transpose.png'
import scas from './assets/scas.png'
import bolt from './assets/bolt.jpg'
import nmet from './assets/nmet.jpg'
import lcs from './assets/lcs.png'
import Egg from './assets/egg.jpg'
import trail from './assets/trail.jpg'
const Ind = () => {
    return (
        <div>
               <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={dpl}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Distinct palindromic substrings</p>
      <NavLink to='/category/Make My Trip Interview question 1'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={revLL} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Reverse a Linked List in groups of given size</p>
      <NavLink to='/category/Make My Trip Interview question 2'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={twojug} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Two water Jug problem</p>
        <NavLink to='/category/Make My Trip Interview question 3'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={mcp} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Minimum Cost Path</p>
      <NavLink to='/category/Make My Trip Interview question 4'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={transpose} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Transpose of Matrix</p>
      <NavLink to='/category/Make My Trip Interview question 5'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={scas} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Smallest window in a string containing all the characters of another string</p>
      <NavLink to='/category/Make My Trip Interview question 6'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={mir} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Check Mirror in N-ary tree</p>
        <NavLink to='/category/Make My Trip Interview question 7'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={lps} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Longest Prefix Suffix</p>
      <NavLink to='/category/Make My Trip Interview question 8'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={Max} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Maximum Difference</p>
      <NavLink to='/category/Make My Trip Interview question 8'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={bolt} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Nuts and Bolts Problem</p>
      <NavLink to='/category/Make My Trip Interview question 9'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={nmet} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>N meetings in one room</p>
        <NavLink to='/category/Make My Trip Interview question 10'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={sub} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>String formation from substring</p>
      <NavLink to='/category/Make My Trip Interview question 11'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={lcs} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Longest Common Subsequence</p>
      <NavLink to='/category/Make My Trip Interview question 12'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    
  
  <div class="card 3">
    <div class="card_image">
      <img src={trail} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Trailing zeroes in factorial</p>
        <NavLink to='/category/Make My Trip Interview question 14'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={Egg} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Egg Dropping Puzzle</p>
      <NavLink to='/category/Make My Trip Interview question 15'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
        </div>
    )
}

export default Ind
